import { createContext } from "react";
import type { Theme, ResolvedTheme } from "./useTheme";

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: ResolvedTheme;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(
  undefined,
);
